import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const DEFAULT_DATALAYER_INTEGRATION_NAME = 'default-datalayer';
export const ZDefaultDatalayerIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(DEFAULT_DATALAYER_INTEGRATION_NAME),
    category: z.literal('analytics'),
    credentials: z.object({}).optional(),
    settings: z.object({}).optional(),
}).shape);
//# sourceMappingURL=default-datalayer.js.map